import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { IFilterListaNegraModel } from 'src/app/models/interfaces/listanegra/IFilterListaNegraModel';
import { IListaNegraModel } from 'src/app/models/interfaces/listanegra/IListaNegraModel';
import { FilterListaNegraModel } from 'src/app/models/listanegra/FilterListaNegraModel';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ListanegraService } from 'src/app/services/listanegra/listanegra.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-listanegra-lista',
  templateUrl: './listanegra-lista.component.html',
  styleUrls: ['./listanegra-lista.component.css']
})
export class ListanegraListaComponent implements OnInit {
  model!: SearchResultModel<IListaNegraModel[]>;
  filter: IFilterListaNegraModel = new FilterListaNegraModel();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();

  resultsLength = 0;
  currentPage = 0;

  displayedColumns: string[] = [
    'nombres',
    'nroDocumentoIdentidad',
    'compania',
    'fecharegistro',
    'registradopor',
    'acciones'
  ];
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(private serviceListanegra: ListanegraService,
    private storage: StorageService,
    private confirmDialogService: ConfirmDialogService) {
    this.model = new SearchResultModel<IListaNegraModel[]>(false, new Array<IListaNegraModel>(), 0, 1, 0);
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.filter.companias.push(usuario.companiaDefault.idCompania);
  }

  ngOnInit(): void {

    this.serviceListanegra.getListPaged(this.filter).subscribe((data) => {
      this.model = data;
      this.resultsLength = data.total;
    });
  }

  search(): void {
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.serviceListanegra
      .getListPaged(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.serviceListanegra
      .getListPaged(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
      });
  }

  deletePersona(element: IListaNegraModel): void {
    this.confirmDialogService.open('¿Seguro de eliminar a la persona de la lista negra?');
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.serviceListanegra.delete(element.idListaNegra).subscribe((result) => {
          this.search();
        });
      }
    });

  }
}
